import { createSelector } from 'reselect';

const selectTaxCategories = (state: any) => state.taxCategories;


export const selectTaxCategoriesCurrentItem = createSelector([selectTaxCategories], (taxCategories) => taxCategories.current);

export const selectTaxCategoriesListItems = createSelector([selectTaxCategories], (taxCategories) => taxCategories.list);

export const selectTaxCategoriesItemById = (itemId: any) =>
    createSelector(selectTaxCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTaxCategoriesQueryItems = createSelector([selectTaxCategories], (taxCategories) => taxCategories.query);

export const selectTaxCategoriesCreatedItem = createSelector([selectTaxCategories], (taxCategories) => taxCategories.create);

export const selectTaxCategoriesUpdatedItem = createSelector([selectTaxCategories], (taxCategories) => taxCategories.update);

export const selectTaxCategoriesReadItem = createSelector([selectTaxCategories], (taxCategories) => taxCategories.read);

export const selectTaxCategoriesDeletedItem = createSelector([selectTaxCategories], (taxCategories) => taxCategories.delete);

export const selectTaxCategoriesSearchedItems = createSelector([selectTaxCategories], (taxCategories) => taxCategories.search);

export const selectTaxCategoriesItemsCount = createSelector([selectTaxCategories], (taxCategories) => taxCategories.count);

export const selectTaxCategoriesItemsFilter = createSelector([selectTaxCategories], (taxCategories) => taxCategories.filter);